import React from 'react';

// @ToDo: @Convis investigate circular imports
import { useFormContext } from "../../context/FormContext/index.js";
import { ComponentType } from "../../types.js";
import { useShouldRenderElement } from "../../utils/shouldRender.js";
import { CustomButton } from "../CustomButton/CustomButton.js";
import { CustomElement } from "../CustomElement/CustomElement.js";
import { CustomFormCheckbox } from "../CustomFormCheckbox/CustomFormCheckbox.js";
import { CustomFormDatepicker } from "../CustomFormDatepicker/CustomFormDatepicker.js";
import { CustomFormDropdown } from "../CustomFormDropdown/CustomFormDropdown.js";
import { CustomFormInput } from "../CustomFormInput/CustomFormInput.js";
import { CustomFormInputPassword } from "../CustomFormInputPassword/CustomFormInputPassword.js";
import { CustomFormInputUnit } from "../CustomFormInputUnit/CustomFormInputUnit.js";
import { CustomFormInputZip } from "../CustomFormInputZip/CustomFormInputZip.js";
import { CustomFormLayout } from "../CustomFormLayout/CustomFormLayout.js";
import { CustomFormRadioGroup } from "../CustomFormRadioGroup/CustomFormRadioGroup.js";
import { CustomFormTextarea } from "../CustomFormTextarea/CustomFormTextarea.js";
import { CustomGrid } from "../CustomGrid/CustomGrid.js";
import { CustomLink } from "../CustomLink/CustomLink.js";
import { CustomTypography } from "../CustomTypography/CustomTypography.js";
import { jsx as _jsx } from "react/jsx-runtime";
const formElements = {
  [ComponentType.BUTTON]: CustomButton,
  [ComponentType.CHECKBOX]: CustomFormCheckbox,
  [ComponentType.CUSTOM_ELEMENT]: CustomElement,
  [ComponentType.DATEPICKER]: CustomFormDatepicker,
  [ComponentType.DROPDOWN]: CustomFormDropdown,
  [ComponentType.FORMLAYOUT]: CustomFormLayout,
  [ComponentType.GRID]: CustomGrid,
  [ComponentType.TYPOGRAPHY]: CustomTypography,
  [ComponentType.INPUT]: CustomFormInput,
  [ComponentType.INPUT_PASSWORD]: CustomFormInputPassword,
  [ComponentType.INPUT_UNIT]: CustomFormInputUnit,
  [ComponentType.INPUT_ZIP]: CustomFormInputZip,
  [ComponentType.LINK]: CustomLink,
  [ComponentType.RADIO_GROUP]: CustomFormRadioGroup,
  [ComponentType.TEXTAREA]: CustomFormTextarea
};
export function ElementRenderer({
  element,
  loading,
  showCheckmark
}) {
  const FormComponent = formElements[element.component];
  const {
    control,
    useSmallFields,
    isFormDisabled
  } = useFormContext();
  const shouldRender = useShouldRenderElement(element);
  if (!FormComponent) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.warn(`[ELEMENT RENDERER]: component of type ${element.component} not found!`);
    }
    return null;
  }
  if (!shouldRender) {
    return null;
  }
  const controlledProps = {
    element,
    control,
    useSmallFields,
    isLoading: loading,
    isFormDisabled,
    showCheckmark
  };
  return /*#__PURE__*/_jsx(FormComponent, {
    ...controlledProps
  });
}